export default function LogoVoxMedia() {
  return (
    <svg width="68" height="9" viewBox="0 0 68 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.9076 0.202637C13.0339 0.202637 12.1798 0.457896 11.4534 0.936137C10.727 1.41438 10.1608 2.09412 9.82644 2.8894C9.49209 3.68469 9.40461 4.5598 9.57506 5.40407C9.74551 6.24833 10.1662 7.02385 10.784 7.63253C11.4018 8.24121 12.1889 8.65573 13.0458 8.82367C13.9027 8.9916 14.7909 8.90541 15.598 8.576C16.4052 8.24658 17.0951 7.68873 17.5805 6.97299C18.0659 6.25726 18.325 5.41578 18.325 4.55497C18.3249 3.40069 17.8594 2.29373 17.031 1.47754C16.2026 0.661342 15.0791 0.202756 13.9076 0.202637ZM13.9076 6.71177C12.7562 6.71177 11.8222 5.74614 11.8222 4.55497C11.8222 3.36379 12.7562 2.39816 13.9076 2.39816C15.059 2.39816 15.9925 3.36379 15.9925 4.55497C15.9925 5.74614 15.0585 6.71177 13.9076 6.71177Z"
        fill="currentColor"
      />
      <path
        d="M0.546631 0.374158L5.01795 8.86679L9.49018 0.374158H6.88305L5.04445 3.91797L3.20584 0.374158H0.546631Z"
        fill="currentColor"
      />
      <path d="M57.8838 0.374608H55.5133V8.74884H57.8838V0.374608Z" fill="currentColor" />
      <path
        d="M45.3695 2.47154V0.374158H38.853V8.74839H45.3695V6.65145H41.3317V5.57012H45.0716V3.55287H41.3317V2.47154H45.3695Z"
        fill="currentColor"
      />
      <path
        d="M50.1332 0.374158H46.5625V8.74749H50.1332C52.4817 8.74749 54.3921 6.86844 54.3921 4.56082C54.3921 2.2532 52.4817 0.374158 50.1332 0.374158ZM49.945 6.62534H48.9603V2.49855H49.945C50.2226 2.49451 50.4984 2.54491 50.7561 2.64681C51.0138 2.74872 51.2484 2.9001 51.4463 3.09214C51.6441 3.28419 51.8012 3.51307 51.9084 3.76548C52.0156 4.01788 52.0708 4.28878 52.0708 4.5624C52.0708 4.83602 52.0156 5.10691 51.9084 5.35932C51.8012 5.61173 51.6441 5.84061 51.4463 6.03265C51.2484 6.2247 51.0138 6.37608 50.7561 6.47798C50.4984 6.57989 50.2226 6.63028 49.945 6.62624"
        fill="currentColor"
      />
      <path
        d="M35.0762 4.07958V8.74839H37.4727V0.374608H34.5037L32.6651 3.8662L30.8269 0.374608H27.8575V8.74839H30.2014V4.07958L32.6386 8.70877L35.0762 4.07958Z"
        fill="currentColor"
      />
      <path
        d="M22.4408 6.54341L23.9358 8.74884H26.7431L23.844 4.56172L26.7166 0.374608H23.9619L22.4669 2.57959H22.4929L20.9979 0.374608H18.2172L21.0898 4.56172L18.1907 8.74884H20.9454L22.4408 6.54341Z"
        fill="currentColor"
      />
      <path
        d="M62.0293 5.83933L63.0871 2.84744L64.1471 5.83933H62.0293ZM64.508 0.374158H61.7209L58.6596 8.74749H61.0355L61.4065 7.66976H64.7749L65.1459 8.74749H67.5725L64.508 0.374158Z"
        fill="currentColor"
      />
    </svg>
  );
}
